import lodashPackageJson from "lodash/package.json";
import dayjsPackageJson from "dayjs/package.json";

export interface JSLibrary {
  version?: string;
  docsURL: string;
  name: string;
  accessor: string[];
  url?: string;
  id?: string;
}

export const defaultLibraries: JSLibrary[] = [
  {
    accessor: ["_"],
    version: lodashPackageJson.version,
    docsURL: `https://lodash.com/docs/${lodashPackageJson.version}`,
    name: "lodash",
  },
  {
    accessor: ["dayjs"],
    version: dayjsPackageJson.version,
    docsURL: `https://github.com/iamkun/dayjs`,
    name: "dayjs",
  },
  {
    accessor: ["moment"],
    version: dayjsPackageJson.version,
    docsURL: `https://day.js.org/docs/en/parse/parse`,
    name: "moment",
  },
  {
    accessor: ["forge"],
    version: "1.3.0",
    docsURL: "https://github.com/digitalbazaar/forge",
    name: "forge",
  },
];

export const JSLibraries = [...defaultLibraries];
export const libraryReservedIdentifiers = defaultLibraries.reduce(
  (acc, lib) => {
    lib.accessor.forEach((a) => (acc[a] = true));
    return acc;
  },
  {} as Record<string, boolean>,
);
